/* Collection toolbar: Select Model dropdown + Sort By sync */
(function () {
  if (window.__collectionToolbarInit) return;
  window.__collectionToolbarInit = true;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLSelectElement)) return;

    // Select Model: single value of the model filter, full page load (resets pagination)
    if (target.hasAttribute('data-model-select')) {
      var url = new URL(target.dataset.urlRemove || window.location.href, window.location.origin);
      url.searchParams.delete('page');
      var option = target.selectedOptions[0];
      if (target.value && option && option.dataset.param) {
        url.searchParams.append(option.dataset.param, target.value);
      }
      window.location.href = url.toString();
      return;
    }

    // Sort By (toolbar) -> keep the hidden sort select inside the drawer in sync,
    // so applying filters from the drawer does not reset the chosen sort
    if (target.id === 'SortByMobile') {
      var drawerSort = document.getElementById('SortBy-mobile');
      if (drawerSort) drawerSort.value = target.value;
    }
  });
})();
